export default "__VITE_ASSET__DYW6vjuW__"